<template>
  <div style="padding: 16px">
    <el-form
      :inline="true"
      :model="formFuzzy"
      label-width="130px"
      class="searchForm"
    >
      <el-form-item label="内容提供商名称:">
        <el-input
          v-model="formFuzzy.namer"
          placeholder="请输入提供商名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="search" @click="onQuery"
          >搜索</el-button
        >
      </el-form-item>
      <el-button
        type="primary"
        class="btn_add_new_cp"
        @click="addcp"
        icon="el-icon-folder-add"
        >新建内容提供商</el-button
      >
    </el-form>
    <div>
      <el-table
        ref="multipleTable"
        :data="queryData"
        :header-cell-style="rowClass"
        tooltip-effect="dark"
        style="width: 100%; margin-bottom: 50px; font-size: 12px"
        v-loading.body="loading"
      >
        <el-table-column prop="id" label="ID" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="内容提供商"
          align="center"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="logo"
          label="封面"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <img :src="scope.row.logo" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column
          prop="appName"
          label="来源"
          align="center"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.created_at | formatDate2 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          show-overflow-tooltip
          align="center"
          width="180"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="管理内容"
              placement="top"
            >
              <el-button
                type="info"
                size="mini"
                icon="el-icon-folder"
                circle
                @click="bookInfo(scope.row)"
                v-if="scope.row.type == 'own'"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="编辑"
              placement="top"
            >
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                circle
                @click="handleEdit(scope.row)"
                v-if="scope.row.type == 'own'"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
            >
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
                @click="handleDelete(scope.row.id)"
                v-if="scope.row.type == 'own'"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="查看内容"
              placement="top"
            >
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-reading"
                circle
                @click="handleView(scope.row)"
                v-if="scope.row.type == 'share'"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :title="editId?'编辑内容提供商':'新建内容提供商'"
      :visible.sync="dialogVisible"
      width="30%"
      center
    >
      <el-form :model="form" label-width="125px">
        <el-form-item label="*名称">
          <el-input
            v-model="form.name"
            placeholder="必填项"
          ></el-input>
        </el-form-item>
        <el-form-item label="封面">
          <el-row type="flex" class="row-bg">
            <el-col :span="6">
              <Upload
                action="/aries-api/resource/upload"
                accept="image/jpeg, image/gif, image/png"
                :before-upload="onBeforeUpload"
                :on-success="onSuccessUpload"
                :data="uploadData"
                :show-upload-list="false"
              >
                <el-button
                  type="success"
                  icon="el-icon-upload"
                  circle
                  size="mini"
                ></el-button>
              </Upload>
            </el-col>
            <el-col :span="18" v-if="form.imgUrl != ''">
              <img :src="form.imgUrl" width="80px" height="80px" />
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>

        <el-button type="primary" @click="confirmAddCp" :loading="loadingBtn"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import { SortLikeWin, checkFormat } from "../book";
export default {
  name: "CPList",
  data() {
    return {
      queryData: [],
      queryNewData: [],
      showData: [],
      dialogVisible: false,
      form: {
        name: "",
        imgUrl: "",
      },
      uploadData: { isOnlyMP3: "false", pdfToPng: "false" },
      editOrAdd: "",
      editId: null,
      loading: true,
      loadingBtn: false,
      formFuzzy: {
        namer: "",
      },
    };
  },
  components: {},
  props: {},
  created() {
    this.fetchQueryData();
  },
  computed: {},
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {},
  watch: {},
  methods: {
    async onQuery() { 
      await this.fetchQueryData()
      // var _this = this;
      // var queryNewData = [];
      //   console.log(this.formFuzzy.namer);

      // if (this.formFuzzy.namer != "") {
      //   console.log(this.formFuzzy.namer);
        // this.queryData.map(function (item) {
        //   console.log(item.name);
        //   if (item.name.search(_this.formFuzzy.namer) != -1) {
        //     this.queryData.push(item);
        //   }
        // });
        // this.queryData = queryNewData;
      // }else{
      //    this.fetchQueryData()
      // }
      // console.log(queryNewData, "queryData查找到的数据========");
            if(!this.queryData){
              return
            }
     var _this = this;
      var queryeverData = [];
      if (this.formFuzzy.namer != "") {

        this.queryData.map(function (item) {
          if (item.name.search(_this.formFuzzy.namer) != -1) {
            queryeverData.push(item);
          }
        });
        console.log(queryeverData, "queryData查找到的数据========");
        this.queryData = queryeverData;
      }else{
        this.fetchQueryData()
      }
      console.log(queryeverData, "queryData查找到的数据========");
    },
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    bookInfo(cp) {
      console.log(cp, "cp>>>>>>>");
      this.$emit("gotoBook", { name: cp.name, id: cp.id });
    },
    handleEdit(cp) {
      this.form.name = cp.name;
      this.form.imgUrl = cp.logo;
      this.editOrAdd = "edit";
      this.editId = cp.id;
      this.dialogVisible = true;
    },
    addcp() {
      this.form.name = "";
      this.form.imgUrl = "";
      this.editOrAdd = "add";
      this.dialogVisible = true;
    },
    handleDelete(id) {
      this.$Modal.confirm({
        title: "确认删除？",
        content:
          "<ul>\
                    <li>请先确保该内容品牌下无关联书籍</li>\
                    <li>删除后无法恢复</li>\
                    <li>删除后可能会导致用户端的未知问题，我们概不负责</li>\
                  </ul>",
        onOk: () => {
          let params = {
            id: id,
            appId: this.$API.APPID,
          };
          this.$axios
            .post("/aries-api/resourceDb/delete", params)
            .then((response) => {
              console.log(response);
              let m = response.data;
              if (m.result == 0) {
                this.fetchQueryData();
                this.$Message.success("删除成功!");
              } else {
                ApiMessage(this, m.msg, "error");
              }
            })
            .catch((error) => {
              ApiMessage(this, error.toString(), "error");
            });
        },
      });
    },
    handleView(cp) {
      this.$emit("", { name: cp.name, id: cp.id });
    },
    fetchQueryData() {
      // let params = {
      //   appId: this.$API.APPID,
      //   //otype: 2,
      //   dtype: 1,
      //   onlyAuthorised: 1,
      //   needAppName: 1,
      // };
      // if (this.formFuzzy.namer != "") {
      //   params.name = this.formFuzzy.namer;
      // }
      // this.$axios
      //   .post("/aries-api/resourceDb/list", params)
      //   .then((response) => {
      //     console.log(response);
      //     if (response.data.result == 0) {
      //       this.queryData = response.data.data.own;
      //       this.loading = false;
      //       return
      //     }
      //   })
      //   .catch((error) => {
      //     ApiMessage(this, error.toString(), "error");
      //   });

      return new Promise((resolve,r)=>{
       let params = {
        appId: this.$API.APPID,
        //otype: 2,
        dtype: 1,
        onlyAuthorised: 1,
        needAppName: 1,
      };
      if (this.formFuzzy.namer != "") {
        params.name = this.formFuzzy.namer;
      }
      this.$axios
        .post("/aries-api/resourceDb/list", params)
        .then((response) => {
          console.log(response);
          if (response.data.result == 0) {
            this.queryData = response.data.data.own;
            this.loading = false;
          }
          resolve()
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
     })
    },
    onBeforeUpload(file) {
      return checkFormat(file, "picture");
    },
    onSuccessUpload(response, file, fileList) {
      console.log(response);
      this.form.imgUrl = response.data[0].url;
      this.$Message.success("上传成功!");
    },
    confirmAddCp() {
      if (this.form.name == "") {
        alert("请填写品牌库的名称");
        return;
      }
      this.loadingBtn = true;

      let params = {
        appId: this.$API.APPID,
        dtype: 1, //选填，cp类型 0 音视频类| 1 书籍类
        name: this.form.name, //必填
        logo: this.form.imgUrl, //选填
        is_open: 1, //必填
        otype: 2, //资源库类型，可选值 0系统库  1开发者库   2应用私有库， 选填
      };
      if (this.editOrAdd == "add") {
        params.id = 0;
      } else if (this.editOrAdd == "edit") {
        params.id = this.editId;
      }
      this.$axios
        .post("/aries-api/resourceDb/save", params)
        .then((response) => {
          this.loadingBtn = false;

          console.log(response);
          if (response.data.result == "0") {
            this.dialogVisible = false;
            this.fetchQueryData();
          } else {
            this.loadingBtn = false;

            alert("post failed");
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../fyd-style.less";
</style>



// WEBPACK FOOTER //
// CPList.vue?e967ff08